import React, { useState } from "react";
import { Dialog, FormControl, DialogTitle, Select, DialogContent, DialogActions, Button, withStyles, MenuItem } from '@material-ui/core';
import * as actions from '../store/profileActions';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const LastUsedPrinter = props => {
    const { classes, lastUsedPrinterFormState, lastUsedPrinter, handleCloseLastUsedPrinterForm, onSaveSettings, activeCustomerID, translations } = props;
    const [selectedPrinter, setSelectedPrinter] = useState(lastUsedPrinter);

    const submitHandler = async () => {
        await onSaveSettings({ LastUsedPrinter: selectedPrinter, type: 'LastUsedPrinter', ActiveCustomerID: activeCustomerID });
        handleCloseLastUsedPrinterForm();
    };

    return (
        <Dialog open={lastUsedPrinterFormState.open}
            onClose={handleCloseLastUsedPrinterForm}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["printers_helper_text"] || "Please select printer from list"}</DialogTitle>
            <DialogContent>
                <FormControl className={classes.formControl} margin={"dense"}>
                    <Select
                        name="language"
                        label={translations["printers"] || "Printers"}
                        margin={"dense"}
                        value={selectedPrinter}
                        fullWidth={true}
                        onChange={(event) => setSelectedPrinter(event.target.value)}
                    >
                        {(lastUsedPrinterFormState && lastUsedPrinterFormState.data ? lastUsedPrinterFormState.data : []).map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseLastUsedPrinterForm} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={submitHandler} variant="contained" className={classes.buttonDanger}>
                    {translations['submit'] || 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        lastUsedPrinter: state?.core?.login?.userSettings?.LastUsedPrinter || '',
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSaveSettings: params => dispatch(actions.saveSettings(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LastUsedPrinter));

